export default __webpack_public_path__ + "static/media/12-11.3bb521cb.png";